import { PropsWithChildren, useEffect, useRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

interface Props {
  height?: number;
  paddingRight?: number;
  paddingLeft?: number;
  scrollBottom?: number | boolean;
  autoHeight?: boolean;
}

export const Scroll = ({
  children, height, paddingRight, paddingLeft, scrollBottom, autoHeight,
}: PropsWithChildren<Props>) => {
  const scrollRef = useRef<Scrollbars>();

  useEffect(() => {
    if (scrollBottom) {
      setTimeout(() => scrollRef.current?.scrollToBottom(), 0);
      setTimeout(() => scrollRef.current?.scrollToBottom(), 50);
      setTimeout(() => scrollRef.current?.scrollToBottom(), 200);
    }
  }, [scrollBottom]);

  return (
    <Scrollbars style={{ height }}
      ref={(ref: any) => {
        scrollRef.current = ref;
      }}
      autoHeight={autoHeight}
    >
      <div style={{ paddingRight, paddingLeft }}>
        {children}
      </div>
    </Scrollbars>
  );
};
